import {
  chunkProductReviewSummaryIds,
  fetchProductReviewSummaryBatch,
} from 'src/lib/trusted-shops/product-review-summaries.client'
import type { ProductReviewSummary } from 'src/lib/trusted-shops/product-reviews'

const queuedRatings = new Map<
  number,
  Array<{
    resolve: (summary: ProductReviewSummary) => void
    reject: (error: unknown) => void
  }>
>()
let batchScheduled = false

export function fetchExperienceRating(publicId: number): Promise<ProductReviewSummary> {
  const promise = new Promise<ProductReviewSummary>((resolve, reject) => {
    const listeners = queuedRatings.get(publicId) ?? []
    listeners.push({ resolve, reject })
    queuedRatings.set(publicId, listeners)
  })

  if (!batchScheduled) {
    batchScheduled = true
    setTimeout(flushQueuedRatings, 0)
  }

  return promise
}

function flushQueuedRatings() {
  batchScheduled = false
  const batch = new Map(queuedRatings)
  queuedRatings.clear()
  const publicIds = [...batch.keys()].toSorted((a, b) => a - b)

  for (const chunk of chunkProductReviewSummaryIds(publicIds)) {
    void resolveRatings(chunk, batch)
  }
}

async function resolveRatings(
  publicIds: number[],
  batch: Map<
    number,
    Array<{
      resolve: (summary: ProductReviewSummary) => void
      reject: (error: unknown) => void
    }>
  >
) {
  try {
    const summaries = await fetchProductReviewSummaryBatch(publicIds)

    for (const publicId of publicIds) {
      for (const { resolve } of batch.get(publicId) ?? []) {
        resolve(summaries[String(publicId)])
      }
    }
  } catch (error) {
    for (const publicId of publicIds) {
      for (const { reject } of batch.get(publicId) ?? []) reject(error)
    }
  }
}
